import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport-31ef3979.mjs";
import { _ as _sfc_main } from "./VaTimeline-e77383a1.mjs";
const VaTimeline = withConfigTransport(_sfc_main);
export {
  VaTimeline as V
};
//# sourceMappingURL=index-591da745.mjs.map
